import type { ReactNode } from "react";
import { TernMark } from "./TernMark";

/** The same quiet account surface for email sign-in and invitation acceptance. */
export function AuthCard({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <div className="onboarding-shell">
      <header className="onboarding-header">
        <a href="/" className="onboarding-brand">
          <TernMark className="h-7 w-7" />
          <span>Tern</span>
        </a>
      </header>
      <main className="onboarding-main">
        <div className="max-w-[420px]">
          <h1 className="text-[30px] font-semibold leading-[1.35] tracking-[-0.8px] text-fg">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-3 text-[14px] leading-7 text-muted">{subtitle}</p>
          )}
          <div className="mt-8 [&_input]:h-11 [&_input]:rounded-lg [&_button[type=submit]]:mt-2 [&_button[type=submit]]:h-11 [&_button[type=submit]]:rounded-lg">
            {children}
          </div>
        </div>
      </main>
      <footer className="onboarding-footer">
        A little more clarity. A lot more possibility.
      </footer>
    </div>
  );
}
